import { render, staticRenderFns } from "./EditorContent.vue?vue&type=template&id=60178038&scoped=true&"
import script from "./EditorContent.vue?vue&type=script&lang=ts&"
export * from "./EditorContent.vue?vue&type=script&lang=ts&"
import style0 from "./EditorContent.vue?vue&type=style&index=0&id=60178038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60178038",
  null
  
)

export default component.exports